import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  getNotificationsByStatus,
  getNotificationsCount,
  getNotificationsCountByType,
} from "../../../core/data/redux/notificationsSlice";
import ApproveNotification from "./ApproveNotification";
import Notification from "./Notification";

const Index: React.FC = () => {
  const dispatch = useDispatch();
  const notificationsState = useSelector(
    (state: any) => state.notificationsState
  );
  const [showApproval, setShowApproval] = useState<boolean>(false);

  const handleToggleView = (): void => {
    setShowApproval(!showApproval);
  };

  const fetchNotificationsCount = () => {
    dispatch(getNotificationsCount({}));
  };
  const fetchNotificationsCountByType = (actionGroup: string) => {
    dispatch(getNotificationsCountByType({ action_group: actionGroup }));
  };
  const fetchNotificationsByStatus = (actionGroup: string) => {
    dispatch(
      getNotificationsByStatus({ is_read: false, action_group: actionGroup })
    );
  };
  useEffect(() => {
    fetchNotificationsCount();
  }, []);
  useEffect(() => {
    if (showApproval) {
      fetchNotificationsCountByType("FOR_APPROVALS");
    } else {
      fetchNotificationsCountByType("MY_NOTIFICATION");
    }
  }, [showApproval]);
  useEffect(() => {
    if (showApproval) {
      fetchNotificationsByStatus("FOR_APPROVALS");
    } else {
      fetchNotificationsByStatus("MY_NOTIFICATION");
    }
  }, [showApproval]);

  let notifications = notificationsState?.notificationsByStatus?.data?.data;

  return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">
                {showApproval ? "Approval Notifications" : "My Notifications "}
              </h2>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap ">
              <div className="me-2 mb-2">
                <div className="">
                  <button
                    onClick={handleToggleView}
                    className="btn btn-danger d-inline-flex align-items-center"
                  >
                    {showApproval
                      ? "Back to My Notifications"
                      : "Approval Notification"}
                  </button>
                </div>
              </div>
            </div>
          </div>

          {showApproval ? (
            <ApproveNotification notificationsData={notifications} />
          ) : (
            <Notification notificationsData={notifications} />
          )}
        </div>
      </div>
    </>
  );
};

export default Index;
